import { storyHeroCoverAttrs, heroCoverAttrsFromPublicPath } from "../../lib/responsive-story-images.js";
import LlAudioSearchCombo from "./ll-audio-search-combo.marko";
import LlPillSearch from "./ll-pill-search.marko";
import LlStoryReaderLocaleText from "./ll-story-reader-locale-text.marko";
import { pickReaderTaglineText } from "../../lib/reader-tagline.js";
import { buildParagraphInnerHtml } from "../../lib/story-sentence-html.js";
import {
  storyReaderBackLinkFullMeta,
  storyReaderDisplayTaglineMeta,
  storyReaderDisplayTitleAidMeta,
  storyReaderDisplayTitleMeta,
} from "../../lib/locale-strings-debug.js";
import GrammarRecommendationsSection from "./grammar-recommendations-section.marko";
import LlReaderPdfBtn from "./ll-reader-pdf-btn.marko";

<if=!input.data.story>
  <div class="container">
    <div class="empty">
      <div class="empty__icon">📖</div>
      <p class="empty__title">${input.data.notFoundTitle}</p>
      <a href=input.data.basePath class="btn btn--outline" style="margin-top:var(--space-md)">← ${input.data.backLabel}</a>
    </div>
  </div>
</if>
<else>
  <div class="container">
    <div class="reader-wrap" id="ll-reader-wrap">
      <main
        class="reader-main ll-text-content"
        id="ll-text-content-root"
        data-content-kind="story"
        data-content-id=(input.data.branchingStoryScene && input.data.branchingStoryScene.scene && input.data.branchingStoryScene.scene.contentId
          ? input.data.branchingStoryScene.scene.contentId
          : (input.data.story.contentId || ""))
      >
        <div class="ll-reader-top-bar">
          <a class="ll-reader-back-link" href=(input.data.branchingStoryScene ? input.data.branchingStoryScene.storiesBasePath : input.data.basePath)>
            <if=input.data.branchingStoryScene>
              ← ${
                input.data.branchingStoryScene.scene.targetTitle ||
                  input.data.branchingStoryScene.scene.title ||
                  input.data.story.targetTitle ||
                  input.data.story.title ||
                  input.data.allLabel
              }
            </if>
            <else>
              <LlStoryReaderLocaleText
                text=("← " + (input.data.allLabel || ""))
                meta=storyReaderBackLinkFullMeta(
                  input.data,
                  input.data.textTools?.uiLang || "en",
                )
              />
            </else>
          </a>
          <if=input.data.pdfUrl>
            <LlReaderPdfBtn
              pdfUrl=input.data.pdfUrl
              title=input.data.downloadPdfLabel
              ariaLabel=input.data.downloadPdfAriaLabel
              label=input.data.pdfAbbrevLabel
            />
          </if>
        </div>

        <if=(!input.data.branchingStoryScene && (input.data.story.learnerTitle || input.data.story.translatedTitle))>
          <p class="title-aid title-aid--detail">
            <LlStoryReaderLocaleText
              text=(input.data.story.learnerTitle || input.data.story.translatedTitle)
              meta=storyReaderDisplayTitleAidMeta(
                input.data.story,
                input.data.textTools?.uiLang || "en",
                input.data.textTools?.targetLang || input.data.story.language || "de",
              )
            />
          </p>
        </if>
        <div class="reader-title-row">
          <h1 class="reader-title">
            <LlStoryReaderLocaleText
              text=(
                input.data.branchingStoryScene && input.data.branchingStoryScene.scene
                  ? (
                      input.data.branchingStoryScene.scene.targetTitle ||
                      input.data.branchingStoryScene.scene.title ||
                      input.data.story.targetTitle ||
                      input.data.story.title
                    )
                  : (input.data.story.targetTitle || input.data.story.title)
              )
              meta=storyReaderDisplayTitleMeta(
                input.data.branchingStoryScene && input.data.branchingStoryScene.scene
                  ? input.data.branchingStoryScene.scene
                  : input.data.story,
                input.data.textTools?.uiLang || "en",
                input.data.textTools?.targetLang || input.data.story.language || "de",
              )
            />
          </h1>
        </div>
        <if=(input.data.story.level || pickReaderTaglineText(input.data.story))>
          <div class="reader-desc-line">
            <if=input.data.story.level>
              <span class=["badge", `badge--${(input.data.story.level || '').toLowerCase()}`, "reader-desc-level"]>${input.data.story.level}</span>
            </if>
            <if=pickReaderTaglineText(input.data.story)>
              <p class="reader-desc reader-desc--plain reader-desc--inline">
                <LlStoryReaderLocaleText
                  text=pickReaderTaglineText(input.data.story)
                  meta=storyReaderDisplayTaglineMeta(
                    input.data.story,
                    input.data.textTools?.uiLang || "en",
                    input.data.textTools?.targetLang || input.data.story.language || "de",
                  )
                />
              </p>
            </if>
          </div>
        </if>

        <if=(input.data.branchingStoryScene && input.data.branchingStoryScene.sceneImagePath)>
          <for|hero| of=[heroCoverAttrsFromPublicPath(input.data.branchingStoryScene.sceneImagePath)]>
            <div class="ll-story-hero ll-story-hero--scene" id="ll-story-hero">
              <div class="ll-story-hero__frame">
                <img
                  class="ll-story-hero__img"
                  src=hero.src
                  data-ll-hero-progressive=hero.progressiveJson
                  alt=(input.data.branchingStoryScene.scene.targetTitle || input.data.branchingStoryScene.scene.title || "")
                  width=hero.width
                  height=hero.height
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                  onError="this.style.display='none';this.parentElement.innerHTML='<div class=&quot;ll-story-hero__fallback&quot;>📖</div>'"
                >
              </div>
            </div>
          </for>
        </if>
        <else>
          <for|hero| of=[storyHeroCoverAttrs(input.data.story)]>
            <div class="ll-story-hero" id="ll-story-hero" style=(input.data.branchingStoryScene ? "display:none" : "")>
              <div class="ll-story-hero__frame">
                <img
                  class="ll-story-hero__img"
                  src=hero.src
                  data-ll-hero-progressive=hero.progressiveJson
                  alt=(input.data.story.targetTitle || input.data.story.title)
                  width=hero.width
                  height=hero.height
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                  onError="this.style.display='none';this.parentElement.innerHTML='<div class=&quot;ll-story-hero__fallback&quot;>📖</div>'"
                >
              </div>
            </div>
          </for>
        </else>

        <div class="ll-reader-audio-dock" id="ll-reader-audio-dock">
          <LlAudioSearchCombo
            showSearch=false
            audioSrc=(input.data.storyAudioSrc || "")
            audioDurationHint=(input.data.storyAudioDurationHint != null ? input.data.storyAudioDurationHint : "")
            audioDebug=(
              input.data.storyAudioSrc
                ? ""
                : (input.data.branchingStoryScene
                    ? (input.data.audioNoSourceDebugFallbackScene || input.data.audioNoSourceDebugFallback || "")
                    : (input.data.audioNoSourceDebugFallbackStory || input.data.audioNoSourceDebugFallback || ""))
            )
            audioTitle=(input.data.audioBadgeLabel || "")
            audioAriaLabel=(input.data.audioBadgeLabel || "")
            scrollFollowTitle=(input.data.scrollFollowTitle || "")
            scrollFollowAriaLabel=(input.data.scrollFollowAriaLabel || "")
          />
        </div>

        <div class="ll-meter-warning" id="ll-meter-warning" style="display:none">
          <span class="ll-meter-warning__text">${input.data.premiumGate?.labels?.meter?.warningBanner || ""}</span>
          <a
            class="ll-meter-warning__cta js-ll-purchase-cta"
            href="#"
            data-ll-analytics="0"
            data-ll-product=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.product)
            data-ll-euros=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.euros)
            data-ll-period=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.period)
            data-ll-tier=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.tier)
            data-ll-audience="lern"
            data-ll-pricing-tier-id=(input.data.premiumGate?.paywallPlans?.tierId)
          >${input.data.premiumGate?.labels?.meter?.ctaGuest || input.data.premiumGate?.labels?.meter?.cta || ""}</a>
        </div>

        <div id="ll-meter-inline-host"></div>

        <if=(input.data.branchingStoryScene && (input.data.branchingStoryScene.dialogRows || []).length)>
          <div class="reader-text ll-branching-scene-script" id="ll-text-root" data-ll-text-root>
            <for|row| of=(input.data.branchingStoryScene.dialogRows || [])>
              <if=(row.kind === "narration")>
                <p>$!{row.textHtml || row.text}</p>
              </if>
              <else>
                <div class=["dialog-line", row.align === "right" ? "dialog-line--pull-right" : "dialog-line--pull-left"]>
                  <if=(row.speaker)><span class="dialog-line__name">${row.speaker}</span></if>
                  <if=(row.textHtml)>
                    <div class="dialog-line__text">$!{row.textHtml}</div>
                  </if>
                  <else>
                    <div class="dialog-line__text">${row.text}</div>
                  </else>
                </div>
              </else>
            </for>
          </div>
        </if>
        <else>
          <div class="reader-text" id="ll-text-root" data-ll-text-root>
            <for|para, paraIdx| of=(Array.isArray(input.data.story.text) ? input.data.story.text : [])>
              <p>$!{buildParagraphInnerHtml(
                String(para || ""),
                (input.data.storyTimestamps || [])[paraIdx] || null,
              )}</p>
            </for>
          </div>
        </else>

        <if=input.data.branchingStoryScene>
          <if=((input.data.branchingStoryScene.sceneChoices || []).length)>
            <section class="ll-ending-unit" id="ll-branching-scene-choices">
              <h2 class="ll-unit-title ll-unit-title--centered">
                ${
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? input.data.branchingStoryScene.continueSingleLabel
                    : input.data.branchingStoryScene.continueMultipleLabel
                }
              </h2>
              <div
                class=[
                  "ll-ending-icon",
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? "ll-ending-icon--stem"
                    : "",
                ]
                aria-hidden="true"
              >${
                (input.data.branchingStoryScene.sceneChoices || []).length === 1 ? "" : "Y"
              }</div>
              <div
                class=[
                  "ll-ending-buttons",
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? "ll-ending-buttons--single"
                    : "",
                ]
              >
                <for|ch, idx| of=(input.data.branchingStoryScene.sceneChoices || [])>
                  <a
                    href=ch.href
                    class=[
                      "ll-unit-card",
                      "ll-ending-btn",
                      (input.data.branchingStoryScene.sceneChoices || []).length === 1
                        ? "ll-ending-btn--single"
                        : idx === 0
                          ? "ll-ending-btn--left"
                          : idx === 1
                            ? "ll-ending-btn--right"
                            : "",
                    ]
                  >
                    <span class="ll-unit-card__title">${ch.text}</span>
                  </a>
                </for>
              </div>
            </section>
          </if>
          <else-if=input.data.branchingStoryScene.isTerminal>
            <section class="ll-branching-scene-end card" id="ll-branching-scene-end">
              <div class="ll-branching-scene-end__card-body">
                <h2 class="ll-branching-scene-end__title">${input.data.branchingStoryScene.endTitle}</h2>
                <div class="ll-branching-scene-end__stats" id="ll-branching-scene-end-stats"></div>
                <a href=input.data.branchingStoryScene.storiesBasePath class="btn btn--outline">${input.data.branchingStoryScene.classicBackOverviewLabel}</a>
              </div>
            </section>
          </else-if>
          <else>
            <div class="ll-branching-scene-end ll-branching-scene-end--fallback" style="margin-top:var(--space-xl)">
              <a href=input.data.branchingStoryScene.storiesBasePath class="btn btn--outline">${input.data.branchingStoryScene.classicBackOverviewLabel}</a>
              <p class="ll-branching-scene-end__hint">${input.data.branchingStoryScene.classicEndSceneLabel}</p>
            </div>
          </else>
        </if>

        <if=(!input.data.branchingStoryScene && (input.data.endingChoices || []).length >= 2)>
          <section class="ll-ending-unit" id="ll-ending-unit">
            <h2 class="ll-unit-title ll-unit-title--centered">${input.data.chooseEndingLabel || ""}</h2>
            <div class="ll-ending-icon" aria-hidden="true">Y</div>
            <div class="ll-ending-buttons">
              <for|ending, idx| of=(input.data.endingChoices || []).slice(0, 2)>
                <button
                  type="button"
                  class=["ll-unit-card", "ll-ending-btn", idx === 0 ? "ll-ending-btn--left" : "ll-ending-btn--right"]
                  data-ending-id=ending.id
                  data-ending-title=(ending.title || ending.label || "")
                  data-ending-text=ending.text
                >
                  <if=(ending.image)>
                    <span class="ll-ending-btn__media">
                      <img
                        class="ll-ending-btn__image"
                        src=(ending.image)
                        alt=""
                        width=(ending.imageWidth)
                        height=(ending.imageHeight)
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  </if>
                  <span class="ll-unit-card__title">${ending.label || ending.title || ending.id}</span>
                </button>
              </for>
            </div>
            <div class="ll-ending-result" id="ll-ending-result" style="display:none">
              <p class="ll-ending-result__label" id="ll-ending-result-label">${input.data.endingChosenLabel || ""}</p>
              <h3 class="ll-ending-result__title" id="ll-ending-result-title"></h3>
              <div class="ll-ending-result__controls" id="ll-ending-result__controls">
                <LlAudioSearchCombo
                  showSearch=false
                  audioButtonId="ll-ending-audio-btn"
                  audioSrc=""
                  audioTitle=(input.data.audioBadgeLabel || "")
                  audioAriaLabel=(input.data.audioBadgeLabel || "")
                  scrollFollowTitle=(input.data.scrollFollowTitle || "")
                  scrollFollowAriaLabel=(input.data.scrollFollowAriaLabel || "")
                />
              </div>
              <div class="ll-ending-result__text" id="ll-ending-result-text"></div>
            </div>
          </section>
        </if>

        <if=input.data.rawModules>
          <section class="ll-exercises-unit" id="ll-exercises-unit">
            <div class="ll-unit-title-row">
              <h2 class="ll-unit-title">${input.data.exerciseUnitTitle || ""}</h2>
            </div>
            <div class="ll-ex-list" id="ll-ex-list"></div>
            <div class="ll-ending-hint-host" id="ll-ending-hint-host" hidden></div>
            <div class="ll-second-ending-promo-host" id="ll-second-ending-promo-host" hidden></div>
            <div class="ll-exercise-lock" id="ll-exercise-lock" style="display:none">
              <div class="ll-exercise-lock__icon">🔒</div>
              <div class="ll-exercise-lock__list" id="ll-exercise-lock-list"></div>
              <a class="btn btn--premium btn--sm" id="ll-exercise-lock-cta" href=(input.data.premiumGate?.paymentLinks?.personal || "#")>${input.data.premiumGate?.labels?.exerciseLock?.unlockCta || ""}</a>
            </div>
          </section>
        </if>

        <if=input.data.grammarRecommendations>
          <GrammarRecommendationsSection rec=input.data.grammarRecommendations/>
        </if>

      </main>

      <div class="ll-word-infobox-backdrop" id="ll-word-infobox-backdrop" aria-hidden="true"></div>
      <aside class="reader-sidebar">
        <div class="reader-sidebar__search" id="ll-sidebar-search-section">
          <LlPillSearch
            id="ll-text-search-input"
            placeholder=(input.data.textTools?.labels?.searchPlaceholder || "")
            searchAriaLabel=(input.data.textTools?.labels?.textSearchAriaLabel || "")
            shellClass="reader-sidebar__search-wrap ll-wortschatz__search-wrap"
            inputClass="ll-search-input ll-wortschatz__search-input reader-sidebar__search-input"
          />
        </div>
        <div class="ll-word-infobox sidebar-section sidebar-section--word-details" id="ll-word-infobox">
          <p class="ll-word-infobox__empty" id="ll-word-infobox-empty">${input.data.wordInfoEmptyLabel || ""}</p>
        </div>
      </aside>
    </div>
  </div>

  <div class="ta-translate-tooltip" id="ll-translate-tooltip">
    <span class="ta-translate-tooltip__body">
      <span class="ta-translate-tooltip__translated" id="ll-tooltip-translated"></span>
      <span class="ta-translate-tooltip__hint" id="ll-tooltip-hint" hidden></span>
    </span>
    <span class="ta-translate-tooltip__more" aria-hidden="true">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11.5v4.5"/><path d="M12 8h.01"/></svg>
    </span>
  </div>

  <html-script id="ll-text-data" type="application/json">
    $!{JSON.stringify({
      contentKind: "story",
      contentId:
        input.data.branchingStoryScene && input.data.branchingStoryScene.scene && input.data.branchingStoryScene.scene.contentId
          ? input.data.branchingStoryScene.scene.contentId
          : input.data.story.contentId || null,
      storySlug: input.data.story.slug || null,
      storyTitle: (typeof input.data.story.targetTitle === "string" ? input.data.story.targetTitle : (typeof input.data.story.title === "string" ? input.data.story.title : null)) || null,
      contentLevel: input.data.story.level || null,
      uiLang: input.data.textTools?.uiLang || null,
      targetLang: input.data.textTools?.targetLang || null,
      storyAudioSrc: input.data.storyAudioSrc || null,
      storyAudioDurationHint: input.data.storyAudioDurationHint || null,
      storyScript: input.data.storyScript || null,
      characters:
        (input.data.branchingStoryScene && input.data.story && input.data.story.characters) ||
        input.data.story.characters ||
        [],
      subtitleLines: input.data.storySubtitleLines || [],
      lexiconOccurrencesUrl: input.data.textTools?.lexiconOccurrencesUrl || "",
      lexiconTextUrl: input.data.textTools?.lexiconTextUrl || "",
      lexiconDataLocale: input.data.textTools?.lexiconDataLocale || "",
      lexiconSectionKey: input.data.textTools?.lexiconSectionKey || "",
      lexiconApiPath: input.data.textTools?.lexiconApiPath || "",
      lexiconApiOrigin: input.data.textTools?.lexiconApiOrigin || "",
      lexiconApiSpeakLang: input.data.textTools?.lexiconApiSpeakLang || "",
      contentApiOrigin: input.data.textTools?.contentApiOrigin || "",
      contentApiDevOrigin: input.data.textTools?.contentApiDevOrigin || "",
      paywallLanternSrc: input.data.textTools?.paywallLanternSrc || "",
      lexiconBundlePath: input.data.textTools?.lexiconBundlePath || "",
      labels: input.data.textTools?.labels || {},
      endings: input.data.endingChoices || [],
      modules: input.data.rawModules || null,
      feedbackLabels: {
        correct: input.data.exerciseCorrectLabel || "",
        incorrect: input.data.exerciseIncorrectLabel || ""
      },
      exerciseLabels: {
        check: input.data.exerciseCheckLabel || "",
        next: input.data.exerciseNextLabel || "",
        reset: input.data.exerciseResetLabel || "",
        tryAgain: input.data.exerciseTryAgainLabel || "",
        showSolution: input.data.exerciseShowSolutionLabel || "",
        hideSolution: input.data.exerciseHideSolutionLabel || "",
        back: input.data.backLabel || "",
        forward: input.data.exerciseNextLabel || "",
        completeTaskFirst: input.data.exerciseCompleteTaskFirstLabel || "",
        points: input.data.exercisePointsLabel || "",
        stars: input.data.exerciseStarsLabel || "",
        summaryTitle: input.data.exerciseSummaryTitle || "",
        summarySubtitle: input.data.exerciseSummarySubtitle || "",
        reward: input.data.exerciseRewardLabel || "",
        setTitlePrefix: input.data.exerciseSetTitlePrefix || "",
        generalInstruction: input.data.exerciseGeneralInstruction || "",
        defaultInstruction: input.data.exerciseDefaultInstruction || "",
        selectOneInstruction: input.data.exerciseSelectOneInstruction || "",
        selectMultipleBlankInstruction: input.data.exerciseSelectMultipleBlankInstruction || "",
        orderVerticalInstruction: input.data.exerciseOrderVerticalInstruction || "",
        typeTitleSelectOne: input.data.exerciseTypeTitleSelectOne || "",
        typeTitleOrderVertical: input.data.exerciseTypeTitleOrderVertical || "",
        typeTitleSelectMultipleBlank: input.data.exerciseTypeTitleSelectMultipleBlank || "",
        typeTitleTypedCloze: input.data.exerciseTypeTitleTypedCloze || "",
        typeTitleVocabMatch: input.data.exerciseTypeTitleVocabMatch || "",
        typeTitleRule: input.data.exerciseTypeTitleRule || "",
        typeInstructionSelectOne: input.data.exerciseTypeInstructionSelectOne || "",
        typeInstructionOrderVertical: input.data.exerciseTypeInstructionOrderVertical || "",
        typeInstructionSelectMultipleBlank: input.data.exerciseTypeInstructionSelectMultipleBlank || "",
        typeInstructionVocabMatch: input.data.exerciseTypeInstructionVocabMatch || "",
        questionAriaPrefix: input.data.exerciseQuestionAriaPrefix || "",
        sectionMainLabel: input.data.exerciseSectionMainLabel || "",
        sectionEndingOneLabel: input.data.exerciseSectionEndingOneLabel || "",
        sectionEndingTwoLabel: input.data.exerciseSectionEndingTwoLabel || "",
        sectionMiddleLabel: input.data.exerciseSectionMiddleLabel || "",
        sectionEndLabel: input.data.exerciseSectionEndLabel || "",
        moduleDoneLabel: input.data.exerciseModuleDoneLabel || "",
        moduleCurrentLabel: input.data.exerciseModuleCurrentLabel || "",
        moduleOpenLabel: input.data.exerciseModuleOpenLabel || "",
        debugCardTitle: input.data.exerciseDebugCardTitle || "",
        debugCardMeta: input.data.exerciseDebugCardMeta || "",
        summaryUnitsLabel: input.data.exerciseSummaryUnitsLabel || "",
        summaryQuestionsLabel: input.data.exerciseSummaryQuestionsLabel || "",
        examModeLabel: input.data.exerciseExamModeLabel || "",
        practiceModeLearnLabel: input.data.exercisePracticeModeLearnLabel || "",
        practiceModeTestLabel: input.data.exercisePracticeModeTestLabel || "",
        practiceModeChooseAria: input.data.exercisePracticeModeChooseAria || "",
        practiceLearnCompleteLabel: input.data.exercisePracticeLearnCompleteLabel || "",
        practiceTestRetryAllLabel: input.data.exercisePracticeTestRetryAllLabel || "",
        practiceTestRetryWrongLabel: input.data.exercisePracticeTestRetryWrongLabel || "",
        practiceTestWrongHint: input.data.exercisePracticeTestWrongHint || "",
        summaryPerfectTitle: input.data.exerciseSummaryPerfectTitle || "",
        summaryPerfectSubtitle: input.data.exerciseSummaryPerfectSubtitle || "",
        summaryPartialTitle: input.data.exerciseSummaryPartialTitle || "",
        summaryPartialSubtitle: input.data.exerciseSummaryPartialSubtitle || "",
        summaryFailedTitle: input.data.exerciseSummaryFailedTitle || "",
        summaryFailedSubtitle: input.data.exerciseSummaryFailedSubtitle || ""
      },
      moduleKindLabels: input.data.moduleKindLabels || {}
      ,
      premiumGate: input.data.premiumGate || null,
      devMeterDebug: process.env.NODE_ENV !== "production",
      devListenTimestampEdit: process.env.NODE_ENV !== "production"
    })}
  </html-script>
  <html-script src="/js/grammar-recommendations-client.js"></html-script>
  <html-script src="/js/text-content-client.js"></html-script>
  <if=input.data.branchingStoryScene>
    <html-script id="ll-branching-story-scene-data" type="application/json">
      $!{JSON.stringify({
        ...(input.data.branchingStoryScene.storyStats || {}),
        scenesDiscoveredTemplate: input.data.branchingStoryScene.scenesDiscoveredTemplate || "",
        endingsCountTemplate: input.data.branchingStoryScene.endingsCountTemplate || "",
        exercisesCountTemplate: input.data.branchingStoryScene.exercisesCountTemplate || "",
      })}
    </html-script>
    <html-script src="/js/branching-story-scene-client.js"></html-script>
  </if>

  <if=input.data.premiumGate>
    <html-script type="application/ld+json">
      $!{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": input.data.story.targetTitle || input.data.story.title || "",
        "description": pickReaderTaglineText(input.data.story) || input.data.story.translatedDescription || input.data.story.description || "",
        "isAccessibleForFree": !input.data.premiumGate.blocked,
        "hasPart": [
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": true,
            "cssSelector": "#ll-text-root"
          },
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": !(input.data.premiumGate.lockExercises),
            "cssSelector": "#ll-exercises-unit"
          }
        ]
      })}
    </html-script>
  </if>
  </else>
